import { useUpdateEntity } from '@abaninja/util-store';

import { approveQuote, declineQuote } from '../documents';

export const useApproveQuoteStore = () => useUpdateEntity(approveQuote);

export const useDeclineQuoteStore = () => useUpdateEntity(declineQuote);
